import { render } from "./Notification.vue?vue&type=template&id=bf967512"
import script from "./Notification.vue?vue&type=script&lang=ts"
export * from "./Notification.vue?vue&type=script&lang=ts"
script.render = render

export default script